import { axiosClient } from './axios_client';

export const getAllInverters = async (params = {}) => {
  try {
    const response = await axiosClient.get('/api/inverters', { params });
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getInverterStatistics = async () => {
  try {
    const response = await axiosClient.get('/api/inverters/statistics');
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getInverterBySerial = async (serialNumber) => {
  try {
    const response = await axiosClient.get(`/api/inverters/serial/${serialNumber}`);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getInverterDetail = async (id) => {
  try {
    const response = await axiosClient.get(`/api/inverters/${id}/detail`);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createInverter = async (data) => {
  try {
    const response = await axiosClient.post('/api/inverters', data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateInverter = async (id, data) => {
  try {
    const response = await axiosClient.put(`/api/inverters/${id}`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateInverterSettings = async (id, data) => {
  try {
    const response = await axiosClient.patch(`/api/inverters/${id}/settings`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteInverter = async (id) => {
  try {
    const response = await axiosClient.delete(`/api/inverters/${id}`);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const inverter_api = {
  getAllInverters,
  getInverterStatistics,
  getInverterBySerial,
  getInverterDetail,
  createInverter,
  updateInverter,
  updateInverterSettings,
  deleteInverter,
};
